
const pt = {
    new_product: 'Novo produto',
    select_active: 'Somente Ativos',
    placeholder_search_reg: 'Buscar registro',
    sku:'SKU',
    description:'Descrição',
    brand:'Marca',
    price:'Preço',
    stock:'Estoque',
    active:'Ativo',
    deactive:'Desativo',
    options:'Opções',
    edit: 'Editar',
    delete: 'Excluir',
    save:'Guardar',
    sku_used: 'Sku usado',
    catalogue:'Catálogo',
    product:'Productos',
    new:'Novo',
    back:'Voltar'
}
export default pt;